"use client";

import React, { useState, forwardRef } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { cn } from "@/lib/utils";
import { Input as ShadcnInput } from "@/components/ui/input";

const Input = forwardRef((props, ref) => {
  const { icon: Icon, type = "text", error, className, ...rest } = props;
  const [showPassword, setShowPassword] = useState(false);
  const inputType = type === "password" && showPassword ? "text" : type;

  return (
    <div className="flex flex-1 flex-col">
      <div className="relative w-full">
        {Icon && (
          <Icon className="absolute left-4 top-1/2 -translate-y-1/2 transform text-gray-500" />
        )}
        <ShadcnInput
          ref={ref}
          className={cn(
            "h-12 w-full",
            Icon ? "px-12" : "pl-4",
            className,
            error
              ? "border-red-500 focus-visible:ring-red-500 dark:border-red-500 dark:focus-visible:ring-red-500"
              : ""
          )}
          type={inputType}
          {...rest}
        />
        {type === "password" && (
          <div
            className="absolute right-4 top-1/2 -translate-y-1/2 transform cursor-pointer text-gray-500"
            onClick={() => setShowPassword(!showPassword)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setShowPassword(!showPassword);
              }
            }}
            role="button"
            tabIndex={0}
            aria-pressed={showPassword}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </div>
        )}
      </div>
      {error && (
        <p className="pl-2 text-red-500">{error.message?.toString()}</p>
      )}
    </div>
  );
});

Input.displayName = "Input";

export default Input;
